<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("certificate.certificateType")
          }}</label>
          <input
            v-model.number="model.cert_type_name"
            type="text"
            readonly
            class="form-control"
            :class="{ 'is-invalid': errors.has('cert_type_name') }"
            :placeholder="$t('certificate.availableInYear')"
          />
          <div class="invalid-feedback" v-if="errors.has('cert_type_name')">
            {{ errors.first("cert_type_name") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("certificate.availableInYear")
          }}</label>
          <input
            v-model.number="model.available_in_year"
            type="number"
            class="form-control"
            :class="{ 'is-invalid': errors.has('available_in_year') }"
            :placeholder="$t('certificate.availableInYear')"
          />
          <div class="invalid-feedback" v-if="errors.has('available_in_year')">
            {{ errors.first("available_in_year") }}
          </div>
        </div>
      </div>
      <div class="row tw-mt-2">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";
export default {
  name: "certificateForm",
  data() {
    return {
      objectContain: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        cert_type_id: null,
        available_in_year: null,
        cert_type_name: null,
      },
    };
  },
  computed: {
    ...mapState("academic/certificate", ["edit_data"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  async created() {
    this.setEditData();
  },
  methods: {
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("academic/certificate/update", {
          id: this.model.cert_type_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.cert_type_id = this.edit_data.cert_type_id;
        this.model.available_in_year = this.edit_data.available_in_year;
        this.model.cert_type_name = this.edit_data.cert_type_name;
      }
    },
    clearEdit() {
      this.model.available_in_year = null;
      this.model.cert_type_name = null;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
</style>